import React, { Fragment } from 'react';

import Link from 'app/common/components/Link';
import { getAppUrl } from 'app/developer-v3/utils';

import { BlockerType } from './constants';

/**
 * Builds the URL to the issues page based on the given id
 * @param id
 */
export const issuesLink = (integrationId: number) =>
  `${getAppUrl(integrationId)}/issues`;

/**
 * A developer is not allowed to publish an integration if it has blocking issues
 * or if it's trying to submit the same version
 * @param id
 */
export const getBlocker = (integrationId: number) => ({
  [BlockerType.loki]: {
    title: 'You have outstanding blocking issues.',
    body: (
      <Fragment>
        Mark blocking issues resolved before submitting for review.{' '}
        <Link href={issuesLink(integrationId)}>View issues</Link>
      </Fragment>
    ),
  },
  [BlockerType.version]: {
    title: 'You can’t submit the same version for review.',
    body: (
      <Fragment>
        Create a new editable version by{' '}
        <Link href={`${getAppUrl(integrationId)}/versions`}>
          cloning your integration
        </Link>
        .
      </Fragment>
    ),
  },
});
